import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { refreshRedesignAccount } from '../../services/redesignAccountStore';

function RefreshAccountOnNavigation() {
    const { pathname } = useLocation();
    const previousPathnameRef = useRef(pathname);

    useEffect(() => {
        if (previousPathnameRef.current === pathname) {
            return;
        }
        previousPathnameRef.current = pathname;
        refreshRedesignAccount();
    }, [pathname]);

    return null;
}

export default RefreshAccountOnNavigation;
